module.exports = __webpack_public_path__ + "img/13.cdd585a3.jpg";